export enum TestType {
  GLOBAL = "Global",
  INTERNAL = "Internal",
  EXTERNAL = "External",
}

export interface TestTypeInterface {
  type: TestType;
  email: string | undefined;
}

export enum ProcessingCode {
  NORMAL = "01",
  ADDITIONAL = "02", // Nachforderung
  COPAYMENT = "03", // Zuzahlungsforderung
  CORRECTION = "04", // Korrekturrechnung
}